export const getSemesterName = (semester: string | undefined) : string => {
    if (!semester) {
        return "";
    }
    if (semester === "All") {
        return "All Semesters";
    }
    if (semester === "unspecified") {
        return "Unspecified Semester";
    }
    if (semester.startsWith('FA')) {
        return "Fall " + " 20" + semester.slice(-2);
    } else if (semester.startsWith('SP')) {
        return "Spring " + " 20" + semester.slice(-2);
    } else if (semester.startsWith('SU')) {
        return "Summer " + " 20" + semester.slice(-2);
    } else if (semester.startsWith('WI')) {
        return "Winter " + " 20" + semester.slice(-2);
    }
    return semester;
}
